// extracted by mini-css-extract-plugin
export default {"root":"vkh9XDRfh4dUFOL5DSqL","wrapper":"pjHwL2B1WNMwj0wqngrN","dot":"GyHjz5x5oFByQ4d7vejf","dot1":"I1AeM4mPNCLLEAMfI2py","dot2":"pOzuP_hH5GvV1_wz2Paq","dot3":"W_vxYZuinVVRJTEw8Ry_"};